import React from "react";

import {
    Card,
    Col,
    Progress,
    Row,
    Statistic,
    Tag,
    Typography
} from "antd";

import {
    MessageOutlined,
    ShopOutlined,
    UserOutlined
} from "@ant-design/icons";

const { Text } = Typography;

const MAX_MESSAGES = 3;

const MessageCounter = ({

                            buyerMessages = 0,

                            sellerMessages = 0

                        }) => {

    const buyerRemaining =

        Math.max(
            0,
            MAX_MESSAGES - buyerMessages
        );

    const sellerRemaining =

        Math.max(
            0,
            MAX_MESSAGES - sellerMessages
        );

    return (

        <Card

            bordered={false}

            style={{

                marginBottom:20,

                borderRadius:12,

                background:"#fafafa"

            }}

        >

            <Row gutter={20}>

                <Col span={12}>

                    <Statistic

                        title="Messages acheteur"

                        value={buyerMessages}

                        prefix={<UserOutlined />}

                        suffix={`/ ${MAX_MESSAGES}`}

                    />

                    <Progress

                        percent={
                            (buyerMessages / MAX_MESSAGES) * 100
                        }

                        size="small"

                        status={

                            buyerMessages >= MAX_MESSAGES

                                ? "exception"

                                : "active"

                        }

                    />

                    <Text type="secondary">

                        Restants :

                        {" "}

                        <Tag

                            color={

                                buyerRemaining === 0

                                    ? "red"

                                    : "green"

                            }

                        >

                            {buyerRemaining}

                        </Tag>

                    </Text>

                </Col>

                <Col span={12}>

                    <Statistic

                        title="Messages vendeur"

                        value={sellerMessages}

                        prefix={<ShopOutlined />}

                        suffix={`/ ${MAX_MESSAGES}`}

                    />

                    <Progress

                        percent={
                            (sellerMessages / MAX_MESSAGES) * 100
                        }

                        size="small"

                        status={

                            sellerMessages >= MAX_MESSAGES

                                ? "exception"

                                : "active"

                        }

                    />

                    <Text type="secondary">

                        Restants :

                        {" "}

                        <Tag

                            color={

                                sellerRemaining === 0

                                    ? "red"

                                    : "green"

                            }

                        >

                            {sellerRemaining}

                        </Tag>

                    </Text>

                </Col>

            </Row>

            <div

                style={{

                    marginTop:18,

                    textAlign:"center"

                }}

            >

                <Tag

                    color="blue"

                    icon={<MessageOutlined />}

                >

                    Maximum autorisé :

                    {" "}

                    {MAX_MESSAGES}

                    {" "}

                    messages par participant

                </Tag>

            </div>

        </Card>

    );

};

export default MessageCounter;